const API_BASE = 'https://ncht.bz/api/admin/api-analytics';

function buildQuery(params = {}) {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') return;
        search.set(key, String(value));
    });
    return search.toString();
}

function authHeaders(explicitToken) {
    const token = explicitToken || localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
    if (!token) {
        throw new Error('Токен авторизации не найден');
    }
    return {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
}

async function request(path, params = {}, token) {
    const query = buildQuery(params);
    const response = await fetch(`${API_BASE}${path}${query ? `?${query}` : ''}`, {
        headers: authHeaders(token)
    });
    if (!response.ok) {
        const text = await response.text();
        throw new Error(`HTTP ${response.status}: ${text}`);
    }
    return response.json();
}

export function getApiOverview(params, token) {
    return request('/overview', params, token);
}

export function getApiTimeseries(params, token) {
    return request('/timeseries', params, token);
}

export function getTopEndpoints(params, token) {
    return request('/top-endpoints', params, token);
}

export function getEndpointDetail(params, token) {
    return request('/endpoint-detail', params, token);
}
